import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#05080A] text-white pt-20 pb-10 border-t border-white/10" data-id="element-406">
      <div className="container mx-auto px-6" data-id="element-407">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-408">
          {/* Brand */}
          <div data-id="element-409">
            <img src="https://cdn.magicpatterns.com/uploads/kEvjjfeq9ckri24mEFMCRs/HOF-logo.png" alt="House of Flavors" className="h-24 w-auto mb-6" data-id="element-410" />
            <div className="flex space-x-4" data-id="element-411">
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-412">
                <Instagram size={20} data-id="element-413" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-414">
                <Facebook size={20} data-id="element-415" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-416">
                <Twitter size={20} data-id="element-417" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#DDA247] transition-colors" data-id="element-418">
                <Youtube size={20} data-id="element-419" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-420">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-421">
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-422">
              <li data-id="element-423">
                <Link to="/events" className="hover:text-white transition-colors" data-id="element-424">
                  Events
                </Link>
              </li>
              <li data-id="element-425">
                <a href="#" className="hover:text-white transition-colors" data-id="element-426">
                  Menu (PDF)
                </a>
              </li>
              <li data-id="element-427">
                <Link to="/corporate-events" className="hover:text-white transition-colors" data-id="element-428">
                  Private Events
                </Link>
              </li>
              <li data-id="element-429">
                <Link to="/bottle-service" className="hover:text-white transition-colors" data-id="element-430">
                  Bottle Service
                </Link>
              </li>
              <li data-id="element-431">
                <a href="https://www.ubereats.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-432">
                  Food Reservation
                </a>
              </li>
              <li data-id="element-433">
                <Link to="/book-now" className="hover:text-white transition-colors" data-id="element-434">
                  Hookah Booking
                </Link>
              </li>
            </ul>
          </div>

          {/* Venues */}
          <div data-id="element-435">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-436">
              Venues
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-437">
              <li data-id="element-438">
                <Link to="/daytime" className="hover:text-white transition-colors" data-id="element-439">
                  Daytime
                </Link>
              </li>
              <li data-id="element-440">
                <Link to="/nightlife" className="hover:text-white transition-colors" data-id="element-441">
                  Nightlife
                </Link>
              </li>
              <li data-id="element-442">
                <Link to="/after-hours" className="hover:text-white transition-colors" data-id="element-443">
                  After Hours
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-444">
            <h3 className="text-[#DDA247] font-bold tracking-widest mb-6 text-sm uppercase" data-id="element-445">
              Contact
            </h3>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-446">
              <li className="flex items-start" data-id="element-447">
                <MapPin className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-448" />
                <span data-id="element-449">
                  13460 Baltimore Ave
                  <br data-id="element-450" />
                  Laurel, Maryland 20707
                </span>
              </li>
              <li className="flex items-center" data-id="element-451">
                <Phone className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-452" />
                <span data-id="element-453">(301) 555-0100</span>
              </li>
              <li className="flex items-center" data-id="element-454">
                <Mail className="w-5 h-5 mr-3 text-[#DDA247] shrink-0" data-id="element-455" />
                <span data-id="element-456">info@houseofflavors.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-457">
          <p data-id="element-458">
            &copy; {new Date().getFullYear()} House of Flavors. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-459">
            <a href="#" className="hover:text-white transition-colors" data-id="element-460">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-461">
              Terms of Use
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-462">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}